/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import useScript from "hooks/useScript";
import React, { useEffect, useRef } from "react";

declare global {
  interface Window {
    FormsWidgetSettings: any;
    formsEventBus: any;
  }
}

const TaskCustomForm = React.memo((props: any) => {
  const {
    userTask,
    customFormRef,
    //drawerWidth,
    //upadatedFormDataAvailable,
    onFormErrors,
    afterCompleteForm,
    afterUpdateForm,
    //organizationId,
    widgetSettings,
  } = props;

  const customFormServiceInstanceId = userTask?.customFormServiceInstanceId || null; //"clxxmaweu003h02s6s10su1hn";// 

  const formMounted = useRef(false);
  const pageContainerRef = useRef<any>();

  useEffect(() => {
    if (customFormServiceInstanceId) {
      window.FormsWidgetSettings = window.FormsWidgetSettings || {};

      window.FormsWidgetSettings.widgets = window.FormsWidgetSettings.widgets || [];

      window.FormsWidgetSettings.widgets.push({
        widget: "complete_form",
        type: "inline",
        mount: `user-task-view-drawer-${customFormServiceInstanceId}`,
        disablePreviouslyFilledInstanceFetching: true,
        mountElement: pageContainerRef.current,
        formInstanceId: customFormServiceInstanceId,
        timezone: "US/Pacific",
        showSubmit: false,
        showSave: false,
        showCard: false,
        showLangs: false,
        submitTrigger: (fn: any) => {
          customFormRef.current.onComplete = () => fn(null, false);
          customFormRef.current.onUpdate = () => fn(null, true);
        },
        onFormSubmit: function (yesno, formfields, gqlResponse, isUpdate) {
          if (isUpdate) {
            afterUpdateForm();
          } else {
            afterCompleteForm();
          }
        },
        /*additionalConfig: {
          claire: {
            endpoint: "https://ikntmbsj4vc2bje7v463wiri4m.appsync-api.us-west-2.amazonaws.com/graphql",
            token: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjdXJyZW50T3JnYW5pemF0aW9uSWQiOiJPUkctZjY3OGMyZTMtZjA5NC00NTIxLWIzY2ItZGJjZDI5YTA5NDExIiwidXNlcl9pZCI6IlVTRVItOTc3ZDVkMDEtOWMzYy00ZGI4LTgwZDItNjJmZDFhMWIzYjY4IiwiaXNfYWN0aXZlIjoidHJ1ZSIsIndpZGdldF9wcmVmZXJlbmNlcyI6WyJSRUZFUlJBTF9JTkJPWCJdLCJpYXQiOjE3MjA2OTg4MjAsImlzX3N0YWZmIjp0cnVlfQ.QQ91kvmU1s59ftHUB5x9TG5ITeU_diXsJa1qiBNO6uQ",
            networkOrganizationId: "ORG-f678c2e3-f094-4521-b3cb-dbcd29a09411",
            apiKey: "da2-vhovir4w3fhzjmhitivcu3clju"
          }
        },*/
        onFormError: onFormErrors,
        token: widgetSettings.customFormsToken,
        autoFillLastResponse: false,
        environment: widgetSettings.environment,
        appsyncGraphqlEndpoint: widgetSettings.appsyncGraphqlEndpoint
      });
      formMounted.current = true;

      return () => {
        if (formMounted.current) {
          if (
            pageContainerRef !== undefined &&
            pageContainerRef?.current?.children
          ) {
            Array.from(pageContainerRef?.current?.children || [])?.forEach(
              (child) => {
                pageContainerRef?.current?.removeChild(child);
              },
            );
          }
          formMounted.current = false;
        }
        /*if (formIndex && window.FormsWidgetSettings?.widgets?.length && window.FormsWidgetSettings.widgets[formIndex]) {
            delete window.FormsWidgetSettings.widgets[formIndex];
          }*/
        if (window.FormsWidgetSettings?.widgets?.length > 0) {
          window.FormsWidgetSettings.widgets.forEach((element: any, index: number) => {
            if (element.complete_form === "complete_form") {
              window.FormsWidgetSettings.widgets.splice(index, 1);
            }
          });
        }
      };
    }
  }, [customFormServiceInstanceId]);

  // TODO Get in proper custom forms URL in a proper way.
  useScript(widgetSettings.customFormsUrl, [customFormServiceInstanceId]);

  return (
    <>
      {customFormServiceInstanceId && (
        <div
          style={{
            paddingBottom: 40,
          }}
          id={`user-task-view-drawer-${customFormServiceInstanceId}`}
          ref={pageContainerRef}
        >
          Loading...
        </div>
      )}
    </>
  );
});

export default TaskCustomForm;
